/*
 * Troca a toolbar do core (dropdown de ordenação + botões) pela barra de
 * navegação do tema. Só o item `toolbar` muda: o aviso de novidades do
 * realtime e o que mais as extensões puserem em contentItems fica onde está.
 */
import { extend } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';
import ListNavigation from './ListNavigation';
export default function installNavigation() {
  extend(IndexPage.prototype, 'contentItems', function (items) {
    if (!items.has('toolbar')) return;
    items.setContent('toolbar', m(ListNavigation, {
      page: this
    }));
  });
}
flarum.reg.add('ramon-canela', 'forum/list/navigation', installNavigation);